export default __webpack_public_path__ + "static/media/STL_UpperVector01.99d8c7bc.png";